"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDJSONParserOption = void 0;
var TDJSONOption_1 = require("./TDJSONOption");
var TDJSONParserOption = /** @class */ (function (_super) {
    __extends(TDJSONParserOption, _super);
    function TDJSONParserOption() {
        var _this = _super.call(this) || this;
        _this.buildTerms();
        return _this;
    }
    TDJSONParserOption.ofDefaultRootType = function (type) { return new TDJSONParserOption().setDefaultRootType(type); };
    TDJSONParserOption.ofMapToString = function () { return new TDJSONParserOption().setDeliminatorKey("=").setDeliminatorValue(", "); };
    TDJSONParserOption.prototype.setDefaultRootType = function (type) {
        this.defaultRootType = type;
        return this;
    };
    TDJSONParserOption.prototype.setDocId = function (id) {
        this.docId = id;
        return this;
    };
    TDJSONParserOption.prototype.setDeliminatorKey = function (val) { this.deliminatorKey = val; return this; };
    TDJSONParserOption.prototype.setDeliminatorValue = function (val) { this.deliminatorValue = val; return this; };
    TDJSONParserOption.prototype.setDeliminatorObject = function (start, end) {
        this.deliminatorObjectStart = start;
        this.deliminatorObjectEnd = end;
        return this;
    };
    TDJSONParserOption.prototype.setDeliminatorArray = function (start, end) {
        this.deliminatorArrayStart = start;
        this.deliminatorArrayEnd = end;
        return this;
    };
    return TDJSONParserOption;
}(TDJSONOption_1.TDJSONOption));
exports.TDJSONParserOption = TDJSONParserOption;
//# sourceMappingURL=TDJSONParserOption.js.map